// extracted by mini-css-extract-plugin
export default {"home":"home_home__Qucyc","card":"home_card__NcJF+","search":"home_search__UJODi"};